// 🎯 AAAS Stripe Promise - Version multilingue
import { loadStripe } from '@stripe/stripe-js';

// ← CHANGÉ : locale dynamique selon la langue de l'utilisateur
// Au lieu de forcer 'en', on utilise 'auto' ou on passe la langue
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
  locale: 'auto' // ← Détection automatique (fr/en/es selon le navigateur)
});

// ← AJOUT : Fonction pour créer une instance Stripe avec une langue spécifique
export const getStripeWithLocale = (lang = 'fr') => {
  const localeMap = {
    'fr': 'fr',
    'en': 'en',
    'es': 'es'
  };
  
  return loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
    locale: localeMap[lang] || 'fr'
  });
};

export default stripePromise;